import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Exercise } from '../../../shared/models/Exercises';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  animations: [
    trigger('listChange', [
      transition('0 => 1, 1 => 2, 2 => 3', [
        style({ 'background-color': 'rgb(175, 202, 11)' }),
        animate(800, style({ 'background-color': 'unset' })),
      ]),
      transition('3 => 2, 2 => 1, 1 => 0', [
        style({ 'background-color': 'rgb(225, 35,  0)' }),
        animate(800, style({ 'background-color': 'unset' })),
      ]),
      transition('* <=> *', [style({ 'background-color': 'rgb(175, 202, 11)' }), animate(800, style({ 'background-color': 'unset' }))]),
    ]),
    trigger('flyInOut', [
      state('in', style({ opacity: '0' })),
      transition('void => *', [style({ opacity: '0' }), animate(100)]),
      transition('* => void', [animate(100, style({ opacity: '0' }))]),
    ]),
  ],
})
export class ExpansionPanelComponent {
  constructor(private translate: TranslateService) {}

  panelOpenState: boolean = false;
  counter: number;

  titleValue: string;
  @Input()
  get title() {
    return this.titleValue;
  }
  set title(val) {
    this.titleValue = val;
    this.titleChange.emit(this.titleValue);
  }
  @Output() titleChange = new EventEmitter();
  @Input() selectedExercises: Exercise[] = [];
  @Output() onDone: EventEmitter<any> = new EventEmitter();
  @Output() onRemove: EventEmitter<Exercise> = new EventEmitter();

  remove(ex: Exercise): void {
    this.onRemove.emit(ex);

    if (this.selectedExercises.length == 0) {
      this.step = 0;
    }
  }

  step = 0;

  public setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  forceSetStep(event: MouseEvent, step: number) {
    this.setStep(step);
    event.stopPropagation();
  }

  prevStep() {
    this.step--;
  }

  imDone() {
    this.onDone.emit();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/expansion-panel/expansion-panel.component.ts